function wdsGetSizesProduct(currProdFamSKU, currentSize, elemId) {
    wdsGetAllProducts().then(allProducts => {
        let sizesData = [];
        for (const product of allProducts) {
            let prodSKU = product.variants[0].sku.split('.');
            let prodFamSKU = prodSKU[0] + '.' + prodSKU[1];
            if (prodFamSKU === currProdFamSKU) {
                for (const tag of product.tags) {
                    if (tag.includes('size--')) {
                        let data = {};
                        data['size'] = tag.replace(/size--|mm/g, "");
                        data['url'] = '/products/' + product.handle;
                        data['image'] = product.images[0].src;
                        data['hover'] = product.images[1].src;
                        sizesData.push(data);
                    }
                }
            }
        }
        sizesData.sort((a, b) => Number(a.size) - Number(b.size));
        let output = '';
        for (const sizesItem of sizesData) {
            output += '<div href="';
            output += sizesItem.url;
            output += '" class="card__variants-option';
            if (Number(sizesItem.size) === Number(currentSize)) {
                output += ' card__variants-option-active';
            }
            output += '" featured="';
            output += sizesItem.image;
            output += '" hover-img="';
            output += sizesItem.hover;
            output += '">';
            output += sizesItem.size;
            output += ' mm</div>';
            console.log(output);
            
        }
        let elem = document.querySelector('.card__variants-' + elemId);
        if (elem) {
            elem.insertAdjacentHTML("beforeend", output);
        }
    }).catch(error => console.error('Ошибка:', error));
}
function wdsGetAllProducts(page = 1, allProducts = []) {
    return new Promise((resolve, reject) => {
        let url = `/products.json?limit=250&page=${page}`;
        fetch(url)
            .then(response => response.json())
            .then(data => {
                allProducts = allProducts.concat(data.products);
                if (data.products.length === 250) {
                    wdsGetAllProducts(page + 1, allProducts).then(resolve).catch(reject);
                } else {
                    resolve(allProducts);
                }
            })
            .catch(error => reject(error));
    });
}
